export default "__VITE_ASSET__DDdFJPWY__"